exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".comhead {\n  color: #828282;\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n.comhead a {\n  color: #828282;\n}\n.comhead a:hover {\n  text-decoration: underline;\n}\n.comhead .toggle {\n  margin-right: 4px;\n}\n.comment-content {\n  margin: 0 0 16px 24px;\n}\n.comment-content code {\n  white-space: pre-wrap;\n}\n.child-comments {\n  margin: 8px 0 8px 22px;\n}\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!../vue-loader/lib/selector.js?style/stylus!./src/components/comment.vue
 ** module id = 98
 ** module chunks = 0
 **/